import * as React from 'react';
import { getAssetPath } from '../../util/images';
import { ActionModal } from '../Modal';

const DeleteSceneModal = props => {
  const { onHide, onConfirm, show } = props;
  return (
    <ActionModal
      onHide={() => onHide()}
      onConfirm={() => onConfirm()}
      show={show}
      icon={getAssetPath('icons/configuration-icon.svg')}
      title=""
      header="Delete scene?"
      description="Scene will be permanently removed from database."
    />
  );
};

export default DeleteSceneModal;
